import api from '../requests';
const FileDownload = require('js-file-download');

export async function getData (url) {
  const response = await api.request({
    method: 'get',
    url: url
  });
  return response.data;
}

export async function downloadData (url, name) {
  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: url
  });

  FileDownload(response.data, `${name}.xlsx`);
}
